module.exports = __webpack_public_path__ + "img/vertical_6_1_0.51e122d0.png";